import { toast } from 'react-toastify';

import { INFO_MODAL_ICONS } from '@src/constants';

import { IAttendee } from '@src/webinar/types';
import { EUserType, ISocketError } from '@src/types';

export const getCustomErrorMessage = ({ errorCode, message }: ISocketError): string => {
  const lowerMsg = message.toLowerCase();

  if (errorCode === 'FORBIDDEN') {
    if (lowerMsg.includes('already in the room')) {
      return 'User already in the room.';
    }
    if (lowerMsg.includes('not allowed')) {
      return 'User not allowed to join room';
    }
    return 'Access forbidden.';
  }

  switch (errorCode) {
    case 'ROOM_NOT_FOUND':
      return 'Webinar room not found.';
    case 'ROOM_NOT_YET_OPENED_BY_HOST':
      return 'The webinar will start once the host joins.';
    case 'TOO_EARLY_TO_START_WEBINAR':
      return 'You can start the webinar only 20 minutes before the scheduled time.';
    case 'USER_NOT_FOUND':
      return 'User not found for this webinar.';
    case 'INVALID_USER_ID':
      return 'Invalid user ID format.';
    case 'BAD_REQUEST':
      return 'User ID is missing or invalid.';
    case 'SERVER_ERROR':
      return 'Something went wrong. Please try again later.';
    default:
      return message || 'An error occurred';
  }
};

export const handleCapacityLimitError = ({
  error,
  typesValues,
  selectedAttendees,
  setInfoModalContent,
  setIsInfoModalOpen,
}: {
  error: any;
  typesValues?: string;
  selectedAttendees: IAttendee[];
  setInfoModalContent: (content: any) => void;
  setIsInfoModalOpen: (isOpen: boolean) => void;
}) => {
  const errorCode = error?.response?.data?.code;
  const errorMessage = error?.response?.data?.error ?? 'Something went wrong';
  const allAreAttendees = selectedAttendees.every((attendee) => attendee?.type === EUserType.ATTENDEE);

  if (errorCode === 'CAPACITY_LIMIT' && (typesValues === EUserType.ATTENDEE || allAreAttendees)) {
    setInfoModalContent({
      size: 'medium',
      title: 'You’ve reached limit',
      description: `You’ve selected ${selectedAttendees.length} attendees, which exceeds your package limit. We recommend deselecting some attendees or upgrading your plan.`,
      icon: INFO_MODAL_ICONS.CAPACITY_LIMIT,
      buttons: [
        {
          text: `Upgrade plan`,
          variant: 'primary',
        },
      ],
    });
    setIsInfoModalOpen(true);
  } else {
    toast.error(errorMessage);
  }
};
